/* eslint-disable react/prop-types */
import { Box, Chip, Typography, Stack } from '@mui/material';

const strings = (value) =>
  Array.isArray(value) ? value.filter((item) => typeof item === 'string' && item.trim()) : [];
const Section = ({ title, children }) => (
  <Box>
    <Typography variant="subtitle2" sx={{ mb: 1 }}>
      {title}
    </Typography>
    {children}
  </Box>
);
const List = ({ items }) => (
  <Box component="ul" sx={{ m: 0, pl: 2.5, '& li + li': { mt: 1 } }}>
    {items.map((item, index) => (
      <li key={index}>
        <Typography variant="body2" sx={{ lineHeight: 1.7 }}>
          {item}
        </Typography>
      </li>
    ))}
  </Box>
);

// `listsOnly`: just the key points / concerns / next steps (the call review window shows the
// summary itself, highlighted).
export default function CallAIReviewPanel({ review, generatedAt, listsOnly }) {
  if (!review || typeof review !== 'object') return null;
  const highlights = strings(review.highlights);
  const concerns = Array.isArray(review.concerns)
    ? review.concerns.filter(
        (item) =>
          item && typeof item === 'object' && (typeof item.title === 'string' || typeof item.description === 'string')
      )
    : [];
  const nextSteps = strings(review.next_steps);
  const sentiment = ['Positive', 'Neutral', 'Negative'].includes(review.sentiment)
    ? review.sentiment
    : 'Unknown sentiment';
  return (
    <Stack spacing={2.5} sx={{ overflowWrap: 'anywhere' }}>
      {!listsOnly && (
        <Typography variant="caption" color="text.secondary">
          AI-generated review of this call{generatedAt ? ` • Generated ${generatedAt}` : ''}
        </Typography>
      )}
      {!listsOnly && (
        <Section title="Summary">
          <Chip size="small" label={sentiment} variant="outlined" sx={{ mb: 1.5 }} />
          <Typography sx={{ fontSize: 16, lineHeight: 1.75, whiteSpace: 'pre-wrap' }}>
            {typeof review.summary === 'string' && review.summary ? review.summary : 'Summary unavailable.'}
          </Typography>
        </Section>
      )}
      {highlights.length > 0 && (
        <Section title="Key points">
          <List items={highlights} />
        </Section>
      )}
      {concerns.length > 0 && (
        <Section title="Concerns / objections">
          <Stack spacing={1.5}>
            {concerns.map((item, index) => (
              <Box key={index}>
                {typeof item.title === 'string' && (
                  <Typography variant="body2" fontWeight={600}>
                    {item.title}
                  </Typography>
                )}
                {typeof item.description === 'string' && (
                  <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                    {item.description}
                  </Typography>
                )}
              </Box>
            ))}
          </Stack>
        </Section>
      )}
      {nextSteps.length > 0 && (
        <Section title="Suggested next steps">
          <List items={nextSteps} />
        </Section>
      )}
    </Stack>
  );
}
